<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Navigation Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Foro' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Detalle del Foro</h1>
              <div class="text-caption grey--text font-weight-medium">Participa en la conversación</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row no-gutters v-if="foro">
          <!-- Sidebar (Minimal for Detail View) -->
          <v-col cols="12" md="3" class="pa-6 border-right">
             <div class="mb-8">
                <v-btn block text color="primary" class="rounded-xl justify-start mb-2" @click="$router.push({ name: 'Foro' })">
                   <v-icon left>mdi-chevron-left</v-icon> Volver al Feed
                </v-btn>
                <v-btn block outlined color="success" class="rounded-xl justify-start mb-2 glass-btn" @click="requestAcess">
                   <v-icon left>mdi-lock-open-outline</v-icon> Solicitar Acceso
                </v-btn>
             </div>

             <!-- Short Stats -->
             <div class="elite-sidebar-section pa-6 rounded-xl text-center mb-8">
                <div class="text-h4 font-weight-black primary--text mb-1">{{ foro.likes }}</div>
                <div class="text-overline font-weight-bold grey--text">Reacciones</div>
             </div>

             <!-- Categories (Optional here, but kept if desired) -->
             <div class="elite-sidebar-section pa-4 rounded-xl">
               <h3 class="text-overline font-weight-black primary--text px-2 mb-4">OTRAS SECCIONES</h3>
               <v-list dense color="transparent" class="pa-0">
                  <v-list-item v-for="(item, i) in categories.slice(0, 5)" :key="i" @click="$router.push({ name: 'ForoCategoria', params: { categoria_id: item.id } })" class="rounded-lg mb-1">
                    <v-list-item-icon class="mr-3">
                      <v-icon x-small :color="item.color || 'primary'">mdi-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
               </v-list>
             </div>
          </v-col>

          <!-- Main Content -->
          <v-col cols="12" md="9" class="pa-0 bg-soft-grey min-vh-detail">
            <!-- Content Card -->
            <div class="pa-0">
               <!-- Detail Content Header -->
               <div class="pa-8 bg-white border-bottom shadow-soft">
                  <div class="d-flex align-center justify-space-between mb-8">
                     <div class="d-flex align-center">
                        <v-avatar size="64" color="primary lighten-5" class="mr-6 elite-avatar-glow">
                           <v-img v-if="foro.alumno && foro.alumno.imagen" :src="foro.alumno.imagen"></v-img>
                           <v-icon v-else color="primary">mdi-account</v-icon>
                        </v-avatar>
                        <div>
                           <div class="d-flex align-center mb-1">
                              <v-chip x-small :color="foro.category.color" class="font-weight-black white--text mr-2" label>{{ foro.category.name }}</v-chip>
                              <span class="text-caption grey--text font-weight-medium">{{ foro.created_at }}</span>
                           </div>
                           <h2 class="text-h5 font-weight-black prism-heading">{{ foro.title }}</h2>
                           <div class="text-body-2 primary--text font-weight-bold">
                              {{ foro.alumno ? `${foro.alumno.Nombres} ${foro.alumno.Apellidos}` : 'Usuario IEA' }}
                           </div>
                        </div>
                     </div>
                     <div class="text-right">
                        <div class="d-flex align-center glass-btn rounded-xl px-4 py-2 border">
                           <v-btn icon @click="like" :disabled="liked" color="success" class="mr-1"><v-icon>mdi-thumb-up</v-icon></v-btn>
                           <v-btn icon @click="dislike" :disabled="disliked" color="red"><v-icon>mdi-thumb-down</v-icon></v-btn>
                        </div>
                     </div>
                  </div>

                  <div class="text-body-1 grey--text text--darken-3 mb-8 content-forum" v-html="foro.content"></div>

                  <!-- Media Content -->
                  <div v-if="foro.images && (foro.images.length > 0 || foro.video)" class="mb-8 rounded-xl overflow-hidden shadow-glow">
                     <v-carousel 
                      v-if="foro.images.length >= 2 || (foro.images.length == 1 && foro.video)" 
                      hide-delimiters 
                      height="450"
                      class="rounded-xl"
                     >
                        <v-carousel-item 
                          v-for="(img, j) in foro.images.filter(d => d.status == 1)" 
                          :key="j" 
                          :src="img.image"
                        ></v-carousel-item>
                        <v-carousel-item v-if="foro.video">
                           <div class="video-container h-full black d-flex align-center">
                              <video width="100%" controls>
                                 <source :src="foro.video" type="video/mp4">
                              </video>
                           </div>
                        </v-carousel-item>
                     </v-carousel>
                     <v-img v-else-if="foro.images.length == 1" :src="foro.images[0].image" max-height="600" contain class="bg-black"></v-img>
                  </div>
               </div>

               <!-- Comments Section -->
               <div class="pa-8">
                  <div class="d-flex align-center justify-space-between mb-8">
                     <h3 class="text-h6 font-weight-black prism-heading d-flex align-center">
                        <v-icon left color="primary">mdi-comment-text-multiple</v-icon>
                        Conversación ({{ foro.comments ? foro.comments.length : 0 }})
                     </h3>
                  </div>

                  <!-- Comment Input -->
                  <v-card flat class="rounded-xl pa-2 mb-12 elite-sidebar-section box-shadow-none border">
                     <v-textarea 
                      solo 
                      flat 
                      background-color="transparent" 
                      rows="3" 
                      v-model="comment"
                      label="Escribe tu respuesta..."
                      hide-details
                      class="elite-comment-input"
                     ></v-textarea>
                     <div class="d-flex justify-end pa-2">
                        <v-btn color="primary" class="rounded-xl font-weight-black shadow-glow px-8" @click="addComment()">ENVIAR RESPUESTA</v-btn>
                     </div>
                  </v-card>

                  <!-- Comments Timeline -->
                  <div v-if="foro.comments && foro.comments.length > 0" class="elite-comments-list pl-4 border-left-dashed">
                     <div v-for="(c, cIndex) in foro.comments" :key="cIndex" class="mb-8 relative c-item">
                        <div class="mb-2 d-flex align-center justify-space-between">
                           <div class="d-flex align-center">
                              <v-avatar size="36" color="primary lighten-5" class="mr-3 border-white-small elite-avatar-glow">
                                 <v-img v-if="c.alumno && c.alumno.imagen" :src="c.alumno.imagen"></v-img>
                                 <v-icon v-else size="18" color="primary">mdi-account</v-icon>
                              </v-avatar>
                              <div>
                                 <span class="text-subtitle-2 font-weight-black mr-2">{{ c.alumno ? `${c.alumno.Nombres}` : 'Estudiante' }}</span>
                                 <span class="text-tiny grey--text font-weight-bold uppercase">Hace {{ gettime(c.updated_at) }}</span>
                              </div>
                           </div>
                           <div class="d-flex align-center">
                              <v-btn icon small @click="likeComment(c)" color="primary" class="mr-2 highlight-btn">
                                 <span class="text-caption font-weight-black mr-1">{{ c.likes }}</span>
                                 <v-icon size="16">mdi-heart-outline</v-icon>
                              </v-btn>
                              <v-btn v-if="c.alumno_id == user.IDStB" icon small color="red" @click="deleteComment(c, cIndex)">
                                 <v-icon size="16">mdi-delete-outline</v-icon>
                              </v-btn>
                           </div>
                        </div>
                        <v-card flat class="pa-4 rounded-xl elite-sidebar-section border">
                           <div class="text-body-2 grey--text text--darken-3" v-html="c.comment"></div>
                        </v-card>
                     </div>
                  </div>
                  <div v-else class="text-center py-10 opacity-30">
                     <v-icon size="48">mdi-comment-outline</v-icon>
                     <div class="text-overline font-weight-black mt-2">Sé el primero en comentar</div>
                  </div>
               </div>
            </div>
          </v-col>
        </v-row>

        <!-- Loading / No Content State -->
        <div v-else class="text-center py-16">
           <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
           <div class="mt-4 text-overline font-weight-black grey--text">Cargando conversación...</div>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
moment.locale('es')


export default {
  name: "Chat",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    categories:[],
    selectedCategory:0,
    foro:null,
    comment:'',
    liked:false,
    disliked:false
  }),
  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.foro = this.$route.params.foro;
    this.getCategories();
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    gettime(date_publish){
      let current_date = moment();
      let published_date = moment(date_publish);
      return (moment.duration(current_date - published_date).humanize())
    },
    async addComment(){
      if(!this.comment) return;
      
      var formData = new FormData();
      formData.append('comment',this.comment);
      formData.append('taged','');

      await this.$API
        .post({
          url: "forums-comment/" + this.foro.id,
          data: formData
        }).then(res => {
            console.log(res)
            res.likes = 0;
            this.foro.comments.unshift(res);
            this.comment = '';
        });
      
    },

    async like(){
      await this.$API
        .post({
          url: "forums-like/" + this.foro.id,
          data: {}
        }).then(res => {
          if(res){
            this.foro.likes ++;
            this.liked = true;
          }
        });
    },

    async likeComment(comment){
      await this.$API
        .post({
          url: "forums-comment-like/" + comment.id,
          data: {}
        }).then(res => {
          if(res){
            comment.likes ++;
          }
        });
    },
    async dislike(){
      await this.$API
        .delete({
          url: "forums-like/" + this.foro.id,
          data: {}
        }).then(res => {
          if(res){
            this.foro.likes --;
            this.disliked = true;
          }
        });
    },

    async deleteComment(comment, j){
      if(confirm('¿Estas seguro de querer eliminar este comentario?')){
        await this.$API
        .delete({
          url: "forums-comment/" + comment.id,
          data: {}
        }).then(res => {
          if(res){
            this.foro.comments.splice(j, 1)
          }
        });
      } 
    },

    async getCategories() {
      await this.$API
        .get({
          url: "forum-categories",
          data: {}
        })
        .then(res => {
          this.categories = res;
        });
    },
    requestAcess() {
       // Minimal implementation based on Detalle.vue logic
       alert('Funcionalidad de solicitud de acceso en desarrollo para esta vista');
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

.bg-soft-grey { background: #f8fafc; }
.border-right { border-right: 1px solid rgba(0,0,0,0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05) !important; }

/* Elite Sidebar */
.elite-sidebar-section {
  background: white;
  border: 1px solid #f1f5f9;
}

/* Elite Cards */
.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
}

.elite-avatar-glow {
  box-shadow: 0 0 15px rgba(26, 35, 126, 0.1);
}

.border-white-small { border: 2px solid white !important; }

/* Detail Specific */
.shadow-soft { box-shadow: 0 4px 20px rgba(0,0,0,0.03) !important; }
.border-left-dashed { border-left: 2px dashed #e2e8f0; }

.elite-comment-input ::v-deep .v-input__control {
  min-height: 0 !important;
}

.highlight-btn:hover { background: rgba(26, 35, 126, 0.05); }

.video-container { width: 100%; border-radius: inherit; }

.shadow-glow {
  box-shadow: 0 10px 20px -5px rgba(26, 35, 126, 0.3) !important;
}

/* Media preview */
.media-preview-box img { object-fit: cover; }

.min-vh-detail { min-height: 80vh; }

.line-height-1 { line-height: 1; }
.text-tiny { font-size: 0.75rem !important; }
.uppercase { text-transform: uppercase; }

.opacity-30 { opacity: 0.3; }

.box-shadow-none { box-shadow: none !important; }

.content-forum { line-height: 1.6; }

/* Responsive adjustments */
@media (max-width: 960px) {
  .border-right { border-right: none !important; border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
}
</style>
